'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPhAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 6.87306e-06C9.33333 -7.72694e-06 18.6667 5.47235e-06 28 5.47235e-06C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V6.87306e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 20H28V10H13.3333L0 20Z", fill: "#DD1C34" }),
      /* @__PURE__ */ jsx("path", { d: "M28 10H13.3333L0 6.87306e-06L28 5.47235e-06V10Z", fill: "#0D4BC3" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2 4C2.36819 4 2.66667 3.70153 2.66667 3.33334C2.66667 2.96515 2.36819 2.66667 2 2.66667C1.63181 2.66667 1.33333 2.96515 1.33333 3.33334C1.33333 3.70153 1.63181 4 2 4Z",
          fill: "#FDD64D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10 10.6667C10.3682 10.6667 10.6667 10.3682 10.6667 10C10.6667 9.63181 10.3682 9.33334 10 9.33334C9.63181 9.33334 9.33333 9.63181 9.33333 10C9.33333 10.3682 9.63181 10.6667 10 10.6667Z",
          fill: "#FDD64D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.66667 16.6667C2.66667 17.0349 2.36819 17.3333 2 17.3333C1.63181 17.3333 1.33333 17.0349 1.33333 16.6667C1.33333 16.2985 1.63181 16 2 16C2.36819 16 2.66667 16.2985 2.66667 16.6667Z",
          fill: "#FDD64D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.53207 11.3266L3.39106 13.0796L3.82379 11.0332C3.75415 10.9763 3.69037 10.9125 3.6335 10.8429L1.58707 11.2756L3.34004 10.1346C3.33561 10.0903 3.33333 10.0454 3.33333 10C3.33333 9.95457 3.33561 9.90968 3.34004 9.86541L1.58707 8.72439L3.6335 9.15712C3.69037 9.08749 3.75415 9.02371 3.82379 8.96684L3.39106 6.9204L4.53207 8.67338C4.57634 8.66894 4.62124 8.66667 4.66667 8.66667C4.7121 8.66667 4.757 8.66894 4.80126 8.67338L5.94228 6.9204L5.50955 8.96684C5.57918 9.02371 5.64296 9.08749 5.69984 9.15712L7.74627 8.72439L5.99329 9.86541C5.99773 9.90967 6 9.95457 6 10C6 10.0454 5.99773 10.0903 5.99329 10.1346L7.74627 11.2756L5.69984 10.8429C5.64296 10.9125 5.57918 10.9763 5.50955 11.0332L5.94228 13.0796L4.80126 11.3266C4.757 11.3311 4.7121 11.3333 4.66667 11.3333C4.62124 11.3333 4.57634 11.3311 4.53207 11.3266Z",
          fill: "#FDD64D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.5 0.37967L0.500024 19.6306L0 20V6.87306e-06L0.5 0.37967Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagPhAsset = forwardRef(FlagPhAsset);

export { VpFlagPhAsset as default };
